import { Spinner } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "~components/Form/components/Loader";
import CardItem from "./CardItem";
const ListSearchs = ({ setShowMessageModal, pesquisas, tipo = "listagem-total", loading, skip, take, setSkip, setLoading, carregando }) => {
  const [itemsToShow, setItemsToShow] = useState(5);
  const [hasMore, setHasMore] = useState(true);
  const previousLengthRef = useRef(pesquisas?.length);

  const loadMoreItems = () => {
    setLoading(true);
    setTimeout(() => {
      const newItemsToShow = itemsToShow + 5;
      const maxItems = pesquisas.length;

      setItemsToShow(Math.min(newItemsToShow, maxItems));
      setSkip(skip + take);

      if (newItemsToShow >= maxItems) {
        setHasMore(false);
      }

      setLoading(false);
    }, 1100);
  };

  useEffect(() => {
    if ((pesquisas.length !== previousLengthRef.current) || itemsToShow == 0 || itemsToShow > pesquisas?.length ) {
      const countItemsToShow = pesquisas.length >= 5 ? 5 : pesquisas.length;
      setItemsToShow(countItemsToShow);
      setHasMore(true);
      previousLengthRef.current = pesquisas.length;
    }
  }, [pesquisas, itemsToShow]);

  return (
    <div className="container mt-1">
      <div className="flex justify-between mt-4">
        {pesquisas?.length > 0 && (
          <>
            <p>
              Exibindo <span className="font-bold">{itemsToShow}</span> de {pesquisas?.length}
            </p>
          </>
        )}
        {carregando && (
          <p className="flex justify-end items-center gap-2 text-sm">
            <Spinner size={"sm"} />
            Verificando se há atualizações nas pesquisas
          </p>
        )}
      </div>



      <InfiniteScroll
        dataLength={itemsToShow}
        next={loadMoreItems}
        hasMore={hasMore}
        loader={loading && <Loader list={true} />}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Fim da lista</b>
          </p>
        }
      >
        <CardItem pesquisas={(pesquisas ?? []).slice(0, itemsToShow)} tipo={tipo} setShowMessageModal={setShowMessageModal}/>
      </InfiniteScroll>
    </div>
  );
};

export default ListSearchs;
